<script setup>
import { computed } from 'vue';

// O NÚMERO QUE ROLA (30/10/2026, Briefing do dia). Cada algarismo de um texto
// ("faltam 56 min", "venceu há 9 dias") é uma fita de 0 a 9 numa janela de
// 1em — o odômetro. Na chegada a fita dá uma volta inteira até o algarismo,
// da esquerda para a direita; depois, quando o valor muda (o relógio do
// briefing anda a cada minuto), ela anda SÓ do algarismo que está na tela até
// o novo — número que muda conta do valor que está na tela, nunca do zero.
// O resto do texto fica parado. O leitor de tela lê o texto inteiro, uma vez.
const props = defineProps({
  texto: { type: String, default: '' },
});

const pedacos = computed(() =>
  props.texto
    .split(/(\d+)/)
    .filter(Boolean)
    .map((parte, i) =>
      /^\d+$/.test(parte)
        ? { i, num: true, digitos: [...parte].map(Number) }
        : { i, num: false, txt: parte }
    )
);

// Duas voltas de fita (0–9, 0–9): o algarismo mora na SEGUNDA, para a
// chegada sempre rodar uma volta inteira, mesmo quando ele é 1.
const FITA = Array.from({ length: 20 }, (_, n) => n % 10);
</script>

<template>
  <span class="rola">
    <span class="sr-only">{{ texto }}</span>
    <template v-for="p in pedacos" :key="p.i">
      <span v-if="!p.num" class="rola__txt" aria-hidden="true">{{
        p.txt
      }}</span>
      <span v-else class="rola__num" aria-hidden="true">
        <!-- Chave pela casa contada da DIREITA: as unidades continuam sendo a
             mesma fita quando "10" vira "9". -->
        <span
          v-for="(d, j) in p.digitos"
          :key="p.digitos.length - j"
          class="rola__casa"
          :style="{ '--d': d, '--j': j }"
        >
          <span class="rola__fita">
            <span v-for="(n, k) in FITA" :key="k" class="rola__alg">{{
              n
            }}</span>
          </span>
        </span>
      </span>
    </template>
  </span>
</template>

<style scoped>
/* Tudo em linha de altura 1 e alinhado pelo topo: a janela do algarismo
   (overflow escondido) e o texto ao lado ficam com a mesma linha de base. */
.rola {
  display: inline-flex;
  align-items: flex-start;
  white-space: pre;
  line-height: 1;
}

/* A fita (0–9, duas voltas) existe só para o desenho: quem seleciona a frase com o mouse não leva os vinte
   algarismos junto. */
.rola__num {
  display: inline-flex;
  user-select: none;
}

.rola__casa {
  display: block;
  overflow: hidden;
  height: 1em;
}

.rola__fita {
  display: flex;
  flex-direction: column;
  transform: translateY(calc((var(--d) + 10) * -1em));
  transition: transform var(--mov-4) var(--mov-curva);
  animation: rolaGira var(--mov-6) var(--mov-curva) backwards;
  animation-delay: calc(
    var(--rola-atraso, 0s) + var(--j) * var(--cascata-passo) * 2
  );
}

.rola__alg {
  height: 1em;
  line-height: 1;
  text-align: center;
  font-variant-numeric: tabular-nums;
}

@keyframes rolaGira {
  from {
    transform: translateY(0);
  }
}
</style>
